import React from "react"
export function CleartripIconMono(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g
        id="prefix__CT-Tick-Monochrome"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__Black-tick">
          <rect
            id="prefix__Combined-Shape"
            fill="currentColor"
            x={0}
            y={0}
            width={24}
            height={24}
            rx={3.487}
          />
          <path
            id="prefix__Fill-6"
            fill="#FFF"
            d="M3.429 12.566l2.124-3.411 2.975 5.116 9.563-8.1 2.124 3.624-12.112 7.672z"
          />
        </g>
      </g>
    </svg>
  )
}
